import { createStyles, UnstyledButton } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ChevronDown } from "components/elements/Icons";
import LinkedUsersModal from "components/elements/LinkedUsersModal";
import ThemeProvider from "components/office-visits/ThemeProvider";
import { useCurrentUser } from "hooks/useCurrentUser";

const useStyles = createStyles(() => ({
  button: {
    backgroundImage: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    display: "flex",
    margin: 0,

    "&:hover": {
      backgroundColor: "transparent",
      backgroundImage: "none",
      boxShadow: "none",
    },
  },
}));

const UserSwitching = () => {
  const { classes } = useStyles();
  const [linkedUsersModalOpened, { toggle: toggleLinkedUsersModal }] = useDisclosure(false);

  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useCurrentUser();

  if (!isCurrentUserSuccess) return null;

  const { linkedUsersToTarget } = currentUser;

  return (
    <ThemeProvider>
      {linkedUsersToTarget.length > 0 && (
        <UnstyledButton className={classes.button} onClick={toggleLinkedUsersModal}>
          <ChevronDown color="#7C859B" size={14} />
        </UnstyledButton>
      )}
      <LinkedUsersModal opened={linkedUsersModalOpened} onClose={toggleLinkedUsersModal} />
    </ThemeProvider>
  );
};

export default UserSwitching;
